import { Component, Input, OnInit } from '@angular/core';

interface AudioModel {
  name: string;
  file: string;
}

@Component({
  selector: 'app-notification-sound',
  templateUrl: './notification-sound.component.html',
  styleUrls: ['./notification-sound.component.scss']
})
export class NotificationSoundComponent implements OnInit {
  @Input() notificationType: string;
  @Input() headerTitle: string;
  @Input() audioList: any[];
  @Input() tooltip: string;
  @Input() audio: AudioModel;
  selectedOption: AudioModel;
  isPlaying = false;
  modal = false;
  percent = 0;

  ngOnInit() {
    this.selectedOption = this.audio;
  }

  showModal() {
    this.modal = true;
    document.querySelector('body').style.overflowY =  'hidden';
  }

  hideModal() {
    this.modal = false;
    document.querySelector('body').style.overflowY =  'auto';
  }

  selectAudio(i) {
    this.selectedOption = this.audioList[i];
  }

  updateAudio() {
    this.audio = this.selectedOption;
  }

}
